import React, { useEffect, useState } from "react";
import "./style.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import Sidebar from "../../../components/sidebar";
import { useOutletContext } from "react-router-dom";
import Button from "react-bootstrap/esm/Button";
import { FiPaperclip, FiSend } from "react-icons/fi";
import { MdSend } from "react-icons/md";
import { LiaLinkSolid } from "react-icons/lia";
import { useDispatch, useSelector } from "react-redux";
import {
  chatWithOpenAi,
  createConversation,
  getChatList,
} from "../../data/redux/chatbot/_chatbotAction";

const Chatbot = () => {
  const { isSidebarOpen } = useOutletContext<{
    isSidebarOpen: boolean;
    onToggleSidebar: () => void;
  }>();
  const dispatch: any = useDispatch();

  const chatDetails = useSelector((state: any) => state?.chatbot);
  const chatData = chatDetails?.chatList || [];

  const [conversationId, setConversationId] = useState<string>("");
  const [messages, setMessages] = useState<any>(chatData);

  const user = useSelector((state: any) => state.user.userDetail);
  const userImage = user?.image || "";

  const [input, setInput] = useState("");
  const [file, setFile] = useState<File | null>(null);

  // Fetch chat data on component mount
  useEffect(() => {
    fetchChatData();
  }, [dispatch]);

  const fetchChatData = async () => {
    try {
      const response = await dispatch(createConversation({}));

      if (response?.payload?.conversation_uuid) {
        setConversationId(response?.payload?.conversation_uuid);
        setMessages(response?.payload?.data);
      }
      return;
    } catch (error: any) {
      console.log("error ===>", error);
    }
  };

  // const handleSend = async () => {
  //   if (!input.trim() && !file) return;

  //   const newMessage = {
  //     id: Date.now(),
  //     message: input || "",
  //     sender_type: "user",
  //   };

  //   // Ensure messages is an array
  //   const currentMessages = Array.isArray(messages) ? messages : [];

  //   // setMessages([...currentMessages, newMessage]);

  //   // Add user message and a temporary "Thinking..." message
  //   const thinkingId = `thinking-${Date.now()}`;
  //   const updatedMessages = [
  //     ...currentMessages,
  //     newMessage,
  //     { id: thinkingId, message: "Thinking...", sender_type: "bot" },
  //   ];

  //   setMessages(updatedMessages);

  //   // Reset input and file
  //   setInput("");
  //   setFile(null);

  //   const response = await dispatch(chatWithOpenAi({ uuid: conversationId, message: input || "" }));
  //   const botResponse = response?.payload?.response;

  //   // Simulated bot reply
  //   setTimeout(() => {
  //     // setMessages((prev: any) => {
  //     //   const safePrev = Array.isArray(prev) ? prev : [];
  //     //   return [
  //     //     ...safePrev,
  //     //     {
  //     //       id: Date.now(),
  //     //       message: botResponse,
  //     //       sender_type: "bot",
  //     //     },
  //     //   ];
  //     // });

  //     setMessages((prev: any) =>
  //       prev.map((msg: any) =>
  //         msg.id === thinkingId
  //           ? { ...msg, message: botResponse } // 🟢 replace the "Thinking..." message
  //           : msg
  //       )
  //     );
  //   }, 1000);
  // };

  const handleSend = async () => {
    if (!input.trim() && !file) return;

    const newMessage = {
      id: Date.now(),
      message: input || "",
      sender_type: "user",
    };

    const thinkingId = `thinking-${Date.now()}`;
    const updatedMessages = [
      ...(Array.isArray(messages) ? messages : []),
      newMessage,
      { id: thinkingId, message: "Thinking...", sender_type: "bot" },
    ];

    setMessages(updatedMessages);
    setInput("");
    setFile(null);

    // ✅ Force React to render the "Thinking..." message before continuing
    await new Promise((resolve) => setTimeout(resolve, 0));

    const response = await dispatch(
      chatWithOpenAi({ uuid: conversationId, message: input || "" })
    );
    console.log('response?.payload >>>> ', response?.payload);

    const botResponse = response?.payload?.response?.friendly_response || "Something went wrong.";

    setMessages((prev: any) =>
      prev.map((msg: any) =>
        msg.id === thinkingId ? { ...msg, message: botResponse } : msg
      )
    );
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setFile(e.target.files[0]);
    }
  };

  const formatAIMessage = (text: any) => {
    if (!text) return "";

    // remove fenced code blocks but only if they contain markdown table
    let cleaned = text.replace(/```markdown|```/g, "");

    // ✔ Detect if there is at least one table row pattern (| col | col |)
    const hasTable = /\|.*\|/.test(cleaned);

    // If table exists, convert it to HTML table
    if (hasTable) {
      cleaned = cleaned.replace(
        /((?:\|.+\|[\r\n]+)+)/g,
        (table: any) => {
          const rows = table.trim().split("\n");

          return `
          <table border="1" cellspacing="0" cellpadding="6" style="border-collapse: collapse; width:100%; font-size:14px;">
            ${rows
              .map((row: any, i: any) => {
                // Skip markdown separator like |----|---|
                if (/^\|\s*-+/.test(row)) return "";

                const cols = row.split("|").map((col: any) => col.trim()).filter(Boolean);

                // header row (first row)
                if (i === 0) {
                  return `<tr>${cols.map((c: any) => `<th style="background:#f2f2f2; text-align:left;">${c}</th>`).join("")}</tr>`;
                }

                // normal table rows
                return `<tr>${cols.map((c: any) => `<td>${c}</td>`).join("")}</tr>`;
              })
              .join("")}
          </table>
        `;
        }
      );
    }

    // Normal formatting (works for all other responses)
    return cleaned
      .replace(/\*\*(.*?)\*\*/g, "<b>$1</b>") // bold
      .replace(/\\n/g, "<br/>")              // literal \n
      .replace(/\n/g, "<br/>");              // real new lines
  }

  return (
    <div className="layout">
      {/* Sidebar */}
      <Sidebar isOpen={isSidebarOpen} />

      {/* Main Content */}
      <main className="content mb-5">
        <div className="chat-bot profileSettings chat-bot-section p-4">
          {/* Header */}
          <div className="chat-bot-top-area p-4 d-flex justify-content-between align-items-center">
            <h2 className="mb-0">Ask Noja</h2>
          </div>

          {/* Chat body */}
          <div
            className="chat-body p-4 pt-5"
            style={{ height: "400px", overflowY: "auto", background: "#fff" }}
          >
            {messages?.map((msg: any) => (
              <div
                key={msg.id}
                className={`d-flex mb-3 ${msg?.sender_type === "user" ? "justify-content-end" : "justify-content-start"}`}
              >
                {msg.sender_type === "bot" && (
                  <div className="me-2 d-flex align-items-end">
                    <div className="p-2 rounded-circle">
                      <img src="../assets/img/chat-bot-icon.svg" />
                    </div>
                  </div>
                )}

                <div
                  className={`p-2 rounded text-break aiMessage ${msg?.sender_type === "user"
                    ? "bg-primary text-white rounded-end text-area-2"
                    : "bg-light text-dark rounded-start text-area"
                    }`}
                  style={{ maxWidth: "60%" }}
                  dangerouslySetInnerHTML={{
                    __html: formatAIMessage(msg?.message || "")
                  }}
                >
                  {/* {msg?.message} */}
                </div>

                {msg.sender_type === "user" && (
                  <div className="ms-2 d-flex align-items-end person-image  ">
                    <img
                      src={
                        userImage
                          ? `${userImage}`
                          : "/assets/img/userCircle.png"
                      }
                      alt="user"
                      className="rounded-circle"
                      width="32"
                      height="32"
                    />
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Input area */}
          <div className="chat-input p-3">
            <div className="position-relative w-100">
              {/* Text Input */}
              <input
                type="text"
                className="form-control rounded-pill send-button"
                placeholder={file ? `Attached: ${file.name}` : "Send a message"}
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleSend()}
                style={{ paddingRight: "90px" }} // extra padding for icons
              />

              {/* Upload (Pin icon) */}
              {/* <label
                htmlFor="fileUpload"
                className="position-absolute top-50 end-0 translate-middle-y me-5"
                style={{ cursor: "pointer" }}
              >
                <LiaLinkSolid size={25} className="text-secondary" />
              </label>
              <input
                type="file"
                id="fileUpload"
                style={{ display: "none" }}
                onChange={handleFileChange}
              /> */}

              {/* Send button */}
              <Button
                variant="send-button"
                className="position-absolute top-50 end-0 translate-middle-y rounded-circle d-flex align-items-center justify-content-center"
                style={{ width: "40px", height: "40px" }}
                onClick={handleSend}
              >
                <MdSend size={35} className="text-white" />
              </Button>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Chatbot;
